import classnames from 'classnames'

import styles from './custom-swiper.module.scss'
import { NAV_POSITION, SwiperProps } from './types/custom-swiper.types'

export const getArrowClasses = ({
  showNavigator,
  totalSlides,
  numberOfVisibleSlides,
  navPosition,
  canNavigate,
}: SwiperProps & {
  canNavigate: boolean | number
  totalSlides: number
}) => {
  return classnames(styles.sliderArrows, {
    [styles.hideSlideArrows]: !showNavigator || totalSlides <= numberOfVisibleSlides,
    [styles.nav__left]: navPosition === NAV_POSITION.LEFT,
    [styles.nav__right_with_padding]: navPosition === NAV_POSITION.RIGHT_WITH_PADDING,
    [styles.nav__right_over_image]: navPosition === NAV_POSITION.RIGHT_OVER_IMAGE,
    [styles.nav__bottom_right_over_image]: navPosition === NAV_POSITION.BOTTOM_RIGHT_OVER_IMAGE,
    [styles.nav__right_with_bottom_padding]: navPosition === NAV_POSITION.RIGHT_WITH_BOTTOM_PADDING,
    [styles.nav__bottom_right]: navPosition === NAV_POSITION.BOTTOM_RIGHT,
    [styles.nav__vertical]: canNavigate && navPosition === NAV_POSITION.VERTICAL,
    [styles.nav__center]: canNavigate && navPosition === NAV_POSITION.CENTER,
    [styles.nav__left_right]: navPosition === NAV_POSITION.LEFT_RIGHT,
  })
}
